/**
 * Frontend constants for viewport-based content signal collection.
 * Mirror backend defaults so that backend can evolve without forcing FE deploys.
 */

/** Minimum accumulated visible time (ms) before an observation is satisfied. */
export const MIN_OBSERVATION_VISIBLE_MS = 300;

/** Minimum visibility ratio (IntersectionObserver) required for time to accumulate. */
export const MIN_OBSERVATION_VISIBILITY_RATIO = 0.5;

/** Dwell below this threshold (ms) + observationSatisfied → quickSkip=true. */
export const QUICK_SKIP_MAX_DWELL_MS = 1500;

/** Cap reported dwell at this value (ms) to prevent outliers from skewing ranking signals. */
export const DWELL_CAP_MS = 30000;
